import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AboutWalkCardConfig } from 'src/environments/environment.interface';

@Component({
  selector: 'app-about-walk-card',
  standalone: false,
  templateUrl: './about-walk-card.component.html',
  styleUrls: ['./about-walk-card.component.scss']
})
export class AboutWalkCardComponent {
  @Input() card: AboutWalkCardConfig | null = null;
}
